var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) { s = '0' + s; }
    return s;
};
function format (date, pattern) {
    pattern = pattern || DEFAULT_PATTERN;
    return pattern.replace(SIGN_REGEXP, function ($0) {
        switch ($0.charAt(0)) {
            case 'y': return padding(date.getFullYear(), $0.length);
            case 'M': return padding(date.getMonth() + 1, $0.length);
            case 'd': return padding(date.getDate(), $0.length);
            case 'w': return date.getDay() + 1;
            case 'h': return padding(date.getHours(), $0.length);
            case 'm': return padding(date.getMinutes(), $0.length);
            case 's': return padding(date.getSeconds(), $0.length);
        }
    });
}

export function timeFormat(fmt) {
    var date = new Date(fmt*1000)//如果date为13位不需要乘1000
    var Y = date.getFullYear() + '-'
    var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
    var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' '
    var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    var m = (date.getMinutes() <10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
    var s = (date.getSeconds() <10 ? '0' + date.getSeconds() : date.getSeconds())
    return Y+M+D+h+m+s
}

export function conversion(date,formats) {
    return format(new Date(date.replace(/-/g, '/')), formats)
}

// 应用 1=当家装修；2当家工匠；3当家商家；4当家小程序
export function appName(type) {
    let name = ''
    switch (type) {
        case '':
            name='全部'
            break;
        case '1':
            name='当家装修'
            break;
        case '2':
            name='当家工匠'
            break;
        case '3':
            name='当家商家'
            break;
        case '4':
            name='当家小程序'
            break;
        default:
            name='未匹配到应用'
            break;
    }
    return name
}

export function filterMoney(money) {
    return money/100
}

// 支付方式
export function filterPayWay(type) {
    let pay = ''
    switch (type) {
        case 'BALANCE':
            pay = '余额支付'
            break;
        case 'ALIPAY_APP':
            pay = '支付宝支付'
            break;
        case 'TENPAY':
            pay = '微信支付'
            break;
        default:
            pay = '未匹配到支付方式'
            break;
    }
    return pay
}